export const domain = process.env.REACT_APP_DOMAIN;
const baseUrl = domain + "v1/api/";
export const mediaPath = domain + "public";
export default baseUrl;
